<!--  -->
<template>
  <div id="app">
    <el-container v-if="$store.state.isLogin!== undefined && $store.state.isLogin"
      style="height: 100%; border: 1px solid #eee">
      <el-header direction="horizontal" style="text-align: right; font-size: 12px">
        <el-container style="float:left;height: 60px; width:200px;border-right: 1px solid #eee">
          <img src="http://img.newlong.com.cn/418d1062-3eeb-45ea-b2e5-4c51f5ea800a.svg"
            style="width:180px;padding:10px" />
        </el-container>
        <!-- <el-dropdown>
          <i class="el-icon-setting" style="margin-right: 15px"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>查看</el-dropdown-item>
            <el-dropdown-item>新增</el-dropdown-item>
            <el-dropdown-item>删除</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
        <span style="margin-right:10px">admin</span>
      </el-header>
      <el-container style="height: 100%;">
        <el-aside width="200px">
          <el-menu @select="handleSelect" :default-active="selectTab.key">
            <label v-for="(submenu, submenu_index) in menus">
              <el-submenu v-if="submenu.children !== undefined && submenu.children.length > 0" :index="submenu.key">
                <template slot="title">
                  <i :class="submenu.icon"></i>
                  <span>{{submenu.menu_name}}</span>
                </template>
                <label v-for="(item2, item2_index) in submenu.children">
                  <el-submenu v-if="item2.children !== undefined && item2.children.length > 0" :index="item2.key">
                    <template slot="title">{{item2.menu_name}}</template>
                    <label v-for="(item3, item3_index) in item2.children">
                      <el-menu-item :index="item3.key">{{item3.menu_name}} </el-menu-item>
                    </label>
                  </el-submenu>
                  <el-menu-item v-else :index="item2.key"> {{item2.menu_name}}</el-menu-item>
                </label>
              </el-submenu>
              <el-menu-item v-else :index="submenu.key">
                <i :class="submenu.icon"></i>
                <span slot="title">{{submenu.menu_name}}</span>
              </el-menu-item>
            </label>
          </el-menu>
        </el-aside>

        <el-container>

          <el-container direction="vertical" style="  background-color: #e9eef3;" height="100%">

            <el-container direction="horizontal" style="max-height:40px;background-color: #fff;  min-height: 40px;"
              class="tabView" height="100%">
              <div class="tab-operation" @click="goLeft()">
                <i class="el-icon-d-arrow-left"></i>
              </div>

              <div class="tab-operation" v-if="homeTab !== undefined && homeMenu!== null"
                :class="[homeTab===selectTab?'tab-selected':'tab-unselected']" @click="toTab(homeTab)">
                <i class="el-icon-error"></i>
              </div>

              <!-- <div class="wrapper"> -->
              <ul class="main-tab" ref="ul_1">
                <li v-for="(tab, index) in tabs" :class="[tabs[index]===selectTab?'tab-selected':'tab-unselected']"
                  @click="tabSelect(index)" :ref="tab.key">

                  {{tab.menu_name}}
                  <i class="el-icon-error" style="margin-left: 5px;" @click.stop="tabClose(index)"></i>
                </li>
              </ul>
              <!-- </div> -->
              <div class="tab-operation" style="border-left: 1px solid #eeeeee;" @click="goRight()">
                <i class="el-icon-d-arrow-right"></i>
              </div>

              <el-dropdown @command="tabsAction">
                <div class="tab-operation">
                  <i class="el-icon-arrow-down"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="closeThis">关闭当前</el-dropdown-item>
                  <el-dropdown-item command="closeOther">关闭其他</el-dropdown-item>
                  <el-dropdown-item command="closeAll">全部关闭</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

            </el-container>
            <el-container>
              <el-main>

                <div style="height:100%;background-color:'#ffffff'">
                  <keep-alive :include="tabKeepKeys">
                    <router-view>
                    </router-view>
                  </keep-alive>

                </div>

              </el-main>
            </el-container>
          </el-container>

        </el-container>
      </el-container>
    </el-container>

    <el-card v-if="$store.state.isLogin!== undefined && !$store.state.isLogin" shadow="hover" class="login-card">
      <img src="http://img.newlong.com.cn/418d1062-3eeb-45ea-b2e5-4c51f5ea800a.svg"
        style="width:250px;margin-top: 10px" />
      <el-form status-icon label-width="100px" class="login-from">

        <el-form-item label="用户名">
          <el-input v-model="user.un"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input type="password" v-model="user.pw" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="float: right;" @click="login">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>

  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';

  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    data() {
      const item = {
        date: "2016-05-02",
        name: "王小虎",
        address: "上海市普陀区金沙江路 1518 弄"
      };
      return {
        user: { un: "", pw: "" },
        isLogin: false,
        tableData: Array(20).fill(item),
        homeMenu: {},
        isClickTab: false,
        tabKeepKeys: [],
        menus: [
          {
            menu_name: "首页",
            // icon: "el-icon-message",
            link: "/a/admin/",
            isHome: true,
            component: "AdminHome"
          },
          {
            menu_name: "公司简介",
            icon: "el-icon-message",
            link: "/a/admin/company",
            component: "AdminCompany"
            // children: [
            //   {
            //     menu_name: "简介、问候、理念",
            //     link: "/a/admin/company",
            //     component: "AdminCompany"
            //   },
            //   {
            //     menu_name: "历史、营业额",
            //     link: "/a/admin/history_turnover",
            //     component: "AdminHistoryTurnover"
            //   }
            // ]
          },
          {
            menu_name: "产品",
            icon: "el-icon-message",
            link: "/a/admin/product",
            component: "AdminProduct"
          },
          {
            menu_name: "轻包装产品",
            icon: "el-icon-message",
            link: "/a/admin/easy",
            component: "AdminEasy"
          },
          {
            menu_name: "企业社会责任",
            icon: "el-icon-message",
            link: "/a/admin/csr",
            component: "AdminCsr"
          },
          {
            menu_name: "新闻",
            icon: "el-icon-message",
            link: "/a/admin/news",
            component: "AdminNews"
          },
          {
            menu_name: "招聘",
            icon: "el-icon-message",
            link: "/a/admin/recruit",
            component: "AdminRecruit"
          },
          {
            menu_name: "联系信息",
            icon: "el-icon-message",
            link: "/a/admin/msg",
            component: "AdminMsg"
          },
          {
            menu_name: "图片库",
            icon: "el-icon-message",
            link: "/a/admin/pictures",
            component: "AdminPictures"
          }
        ],
        tabs: [],
        historyTabStack: [],
        selectTab: {},
        msg: "msg-msg"
      };
    },
    methods: {
      login() {
        var that = this;
        that.$request.post({
          url: "/api/login",
          params: that.user,
          callback: {
            success: function (data) {
              if (data.code == 200) {
                that.isLogin = true;
              } else {
                that.$alert("登录错误", "提示", {
                  confirmButtonText: "确定",
                });
              }
            },
            err: function (err) {
              that.$alert("登录错误", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        });
      },
      toOne() {
        this.$router.push({ path: "one" });
      },
      tabSelect(index) {
        var menu = this.tabs[index];
        if (menu !== this.selectTab) {
          this.toTab(menu);
        }
      },
      tabsAction(command) {
        if (command == "closeThis") {
          this.tabClose(this.tabs.indexOf(this.selectTab));
        } else if (command == "closeOther") {
          this.tabKeepKeys = [this.selectTab.component];
          this.tabs = [this.selectTab];
          this.historyTabStack = [this.homeTab, this.selectTab];
        } else if (command == "closeAll") {
          if (this.homeTab != undefined && this.homeMenu != null)
            this.tabKeepKeys = [this.homeTab.component];
          this.tabs = [];
          this.historyTabStack = [this.homeTab];
          this.selectTab = this.homeTab;
        }
        this.toTab(this.selectTab);
      },

      handleSelect(key, keyPath) {
        var keyStr = key + "";
        var tabKeys = keyStr.split("-");
        var menu = null;
        for (var i in tabKeys) {
          var tkey = tabKeys[i];
          if (tkey.length < 1) continue;
          if (i == 0) {
            menu = this.menus[tkey];
          } else {
            menu = menu.children[tkey];
          }
        }
        menu.key = key;
        this.toTab(menu);
      },
      tabClose(index) {
        var willDelTab = this.tabs[index];

        var i = this.tabKeepKeys.indexOf(willDelTab.component);
        if (i >= 0) this.tabKeepKeys.splice(i, 1);

        this.tabs.splice(index, 1);
        var i = this.historyTabStack.indexOf(willDelTab);
        if (i >= 0) this.historyTabStack.splice(i, 1);
        if (this.historyTabStack.length > 0 && !this.selectTab.isHome) {
          var tab = this.historyTabStack[this.historyTabStack.length - 1];
          // if (tab.isHome) {
          //   this.selectTab = tab;
          // } else {
          this.toTab(tab);
          // }
        }
      },
      toTab(menu) {
        if (menu !== undefined && menu.link !== undefined) {
          if (this.tabKeepKeys.indexOf(menu.component) <= 0)
            this.tabKeepKeys.push(menu.component);
          this.$router.push({ path: menu.link });
          if (menu.isHome) {
            this.selectTab = menu;
          } else {
            var index = this.historyTabStack.indexOf(menu);
            if (index > -1) {
              this.historyTabStack.splice(index, 1);
            }
            this.historyTabStack.push(menu);
            this.selectTab = menu;
            if (this.tabs.indexOf(menu) < 0) this.tabs.push(this.selectTab);
          }
          this.isClickTab = true;
        }
      },
      goLeft() {
        var ul = this.$refs.ul_1;
        ul.scrollLeft = ul.scrollLeft - 400;
      },
      goRight() {
        var ul = this.$refs.ul_1;
        ul.scrollLeft = ul.scrollLeft + 400;
      },
      changeTabSelectPosition() {
        if (!this.isClickTab) return;
        // alert("测量一次")
        this.isClickTab = false;
        var selectTabIndex = this.tabs.indexOf(this.selectTab);
        if (selectTabIndex >= 0) {
          var ul = this.$refs.ul_1;
          if (ul !== undefined) {

            var lis = ul.children;

            var ulWidth = ul.offsetWidth;

            var selectLiRight = 0;
            var selectLiLeft = 0;

            for (var index in lis) {
              var indexW = lis[index].offsetWidth;
              indexW = indexW == undefined ? 0 : indexW;
              if (indexW > 0) {
                selectLiLeft = selectLiRight;
                selectLiRight = selectLiLeft + indexW;
                if (index == selectTabIndex) {
                  break;
                }
              }
            }
            selectLiLeft = selectLiLeft - ul.scrollLeft;
            selectLiRight = selectLiRight - ul.scrollLeft;
            if (selectLiLeft < 0) {
              ul.scrollLeft = ul.scrollLeft + selectLiLeft;
            } else if (selectLiRight > ul.offsetWidth) {
              ul.scrollLeft = ul.scrollLeft + selectLiRight - ul.offsetWidth;
            }
          }
        }
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
      var homeMenu = null;
      var selectPath = this.$route.path;
      for (var index in this.menus) {
        var menu = this.menus[index];
        menu.key = index + "-";
        if (menu.isHome) {
          homeMenu = menu;
        }
        if (selectPath == menu.link) {
          this.selectTab = menu;
        }
        for (var index2 in menu.children) {
          var menu2 = menu.children[index2];
          menu2.key = index + "-" + index2;
          if (menu2.isHome) {
            homeMenu = menu2;
          }
          if (selectPath == menu2.link) {
            this.selectTab = menu2;
          }
          for (var index3 in menu2.children) {
            var menu3 = menu2.children[index3];
            menu3.key = index + "-" + index2 + "-" + index3;
            if (menu3.isHome) {
              homeMenu = menu3;
            }
            if (selectPath == menu3.link) {
              this.selectTab = menu3;
            }
          }
        }
      }
      this.historyTabStack.push(homeMenu);
      if (this.homeTab != undefined && this.homeMenu != null)
        this.tabKeepKeys.push(homeMenu.component);
      this.homeTab = homeMenu;
      if (this.selectTab == undefined || this.selectTab == null) {
        this.selectTab = homeMenu;
      } else {
        this.toTab(this.selectTab);
      }
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

      this.$request.post({
        url: "/api/check",
        // params: { a: "am" },
        callback: {
          success: function (data) {
          },
          err: function (err) {
          }
        }
      });
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
      this.changeTabSelectPosition();
      // alert("有存在更新")
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
  };
</script>
<style scoped>
  /* @import url('../../assets/css/all.css');  */
  /* //@import url(); 引入公共css类 */

  #app {
    padding: 0%;
    font-family: Helvetica, sans-serif;
    text-align: center;
    padding: 0px;
    margin: 0px;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    border: hidden;
  }

  .el-footer {
    background-color: #b3c0d1;
    color: #333;
    text-align: center;
    line-height: 60px;
  }

  .el-menu {
    text-align: left;
  }

  /* .el-aside {
  background-color: #d3dce6;
  color: #333;
  text-align: center;
  line-height: 200px;
} */

  .el-main {
    color: #333;
    text-align: center;
    padding: 0px;
    margin: 10px;
  }

  body>.el-container {
    margin-bottom: 40px;
  }

  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }

  .el-header {
    background-color: #fff;
    color: #333;
    line-height: 60px !important;
    height: 60px !important;
    padding: 0px;
    margin: 0px;
    border-bottom: 1px solid #eee;
  }

  .el-aside {
    color: #ffffff;
    height: 100%;
    /* background-color: rgb(238, 241, 246); */
  }

  .el-breadcrumb {
    padding-left: 10px;
    line-height: 40px;
  }

  .main-tab {
    width: 100%;
    height: 40px;
    margin: 0px;
    padding: 0px;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-align: left;
    /* overflow-x: auto; */
    display: -webkit-flex;
    display: flex;
    -webkit-flex-flow: row nowrap;
  }

  .main-tab li {
    /* width: 100px; */
    list-style: none;
    font-size: 14px;
    font-style: normal;
    cursor: pointer;
    border-right: 1px solid #eeeeee;
    vertical-align: top;
    padding: 0 15px;
    /* margin-left: -5px; */
    line-height: 40px;
    display: inline-block;
  }

  .main-tab i {
    color: #cccccc;
  }

  .main-tab i:hover {
    color: #ff7f00;
  }

  .tab-unselected {
    background-color: #ffffff;
    border-top: 2px solid transparent;
  }

  .tab-selected {
    background-color: #eeeeee;
    border-top: 2px solid #5cacee;
  }

  .main-tab li:hover {
    background: #eee;
  }

  .tab-operation {
    line-height: 40px;
    border-right: 1px solid #eeeeee;
    padding: 0 15px;
    cursor: pointer;
  }

  .tab-operation:hover {
    background: #eee;
  }

  .tabView i {
    line-height: 40px !important;
  }

  /* [class*=" el-icon-"], [class^=el-icon-]{
    line-height: normal !important;
  } */

  .login-card {
    width: 500px;
    height: 280px;
    margin: 100px auto;
  }

  .login-from {
    margin-top: 30px;
  }
</style>